import { render } from "./Attendance.vue?vue&type=template&id=4eab5b7c&bindings={\"classrooms\":\"props\",\"filters\":\"props\",\"report_data\":\"props\",\"students_text_box_disabled\":\"data\",\"students\":\"data\",\"getStudents\":\"options\",\"generateReport\":\"options\",\"resetReportData\":\"options\"}"
import script from "./Attendance.vue?vue&type=script&lang=js"
export * from "./Attendance.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4eab5b7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4eab5b7c')) {
    api.reload('4eab5b7c', script)
  }
  
  module.hot.accept("./Attendance.vue?vue&type=template&id=4eab5b7c&bindings={\"classrooms\":\"props\",\"filters\":\"props\",\"report_data\":\"props\",\"students_text_box_disabled\":\"data\",\"students\":\"data\",\"getStudents\":\"options\",\"generateReport\":\"options\",\"resetReportData\":\"options\"}", () => {
    api.rerender('4eab5b7c', render)
  })

}

script.__file = "resources/js/Pages/Reports/Attendance.vue"

export default script